import { congratulationsPopupResources } from '../../../core/gameConstants';
import { BaseCongratulationsPopup } from './BaseCongratulationsPopup';

class CongratulationsMobilePopup extends BaseCongratulationsPopup {
  constructor() {
    super();
    this.loader = this.createLoader();
    this.resources = null;
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(congratulationsPopupResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  async onLoad() {
    return this.loadResource();
  }

  executeMobile({ root }) {
    return this.loadResource().then(() => {
      const container = this.getPopup({
        onClick: this.onClick(),
      });
      root.addChild(container);
    });
  }
}

export const congratulationsMobilePopup = new CongratulationsMobilePopup();
